"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

/**
 * @function
 * @param {object} props
 * @param {string} props.value ISO-8601 date string
 * @param {boolean} [props.timezone='UTC']
 * @param {string} [props.format]
 * @returns {React.ReactElement}
 * @example
 * <DateFormat value="2020-10-15T10:45:41+00:00" format="ll hh:mm" />
 */
var DateFormat = function DateFormat(_ref) {
  var value = _ref.value,
      format = _ref.format,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? 'UTC' : _ref$timezone;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _momentTimezone["default"])(value).tz(timezone).format(format));
};

var _default = /*#__PURE__*/(0, _react.memo)(DateFormat);

exports["default"] = _default;